import { Instance, types } from 'mobx-state-tree'

const QrAgentConfig = types
  .model('Config', {
    showPopup: types.optional(types.boolean, true),
    showHeaderCloseIcon: types.optional(types.boolean, true),
    isModalDisplaying: types.optional(types.boolean, false),
    closeModal: types.optional(types.boolean, false),
    isActivationDone: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    updateShowPopup(show: boolean) {
      self.showPopup = show
    },
    updateModalDisplaying(isDisplaying: boolean) {
      self.isModalDisplaying = isDisplaying
    },
    updateCancelModal(isCancel: boolean) {
      self.closeModal = isCancel
    },
    updateActivation(isActivationDone: boolean) {
      self.isActivationDone = isActivationDone
    },
  }))

const configData = QrAgentConfig.create({
  showPopup: false,
  showHeaderCloseIcon: false,
  isModalDisplaying: false,
  closeModal: false,
  isActivationDone: false,
})

export type ConfigType = Instance<typeof QrAgentConfig>
export { QrAgentConfig, configData }
